<template>
  <div
    class="tw-flex tw-flex-wrap tw-items-center tw-gap-2"
    data-testid="users-toolbar"
  >
    <div class="tw-w-[250px]" data-testid="users-filters-search">
      <SfSearchInput
        :model-value="search ?? ''"
        :show-result-navigation="false"
        :placeholder="I18n.t('user.filters.search_placeholder')"
        @update:model-value="setSearch($event ?? '')"
        @clear="setSearch('')"
      />
    </div>
    <UsersFilterDropdown
      :label="I18n.t('user.filters.role.label')"
      :options="roleOptions"
      :model-value="role ?? ALL_FILTER_VALUE"
      dropdown-id="users-filter-role"
      data-testid="users-filters-role"
      @update:model-value="setRole"
    />
    <UsersFilterDropdown
      :label="I18n.t('user.filters.status.label')"
      :options="STATUS_FILTER_OPTIONS"
      :model-value="status ?? ALL_FILTER_VALUE"
      dropdown-id="users-filter-status"
      data-testid="users-filters-status"
      @update:model-value="setStatus"
    />
    <UsersFilterDropdown
      :label="I18n.t('user.filters.last_login.label')"
      :options="LAST_LOGIN_FILTER_OPTIONS"
      :model-value="lastLogin ?? ALL_FILTER_VALUE"
      dropdown-id="users-filter-last-login"
      data-testid="users-filters-last-login"
      @update:model-value="setLastLogin"
    />
    <SfButtonDs
      v-if="isFiltered"
      variant="tertiary"
      size="lg"
      icon-before="xmark"
      data-testid="users-filters-clear"
      @click="clearFilters"
    >
      {{ I18n.t('user.filters.clear') }}
    </SfButtonDs>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { SfButtonDs } from '@silverfin/ui-components'
import SfSearchInput from '@app/shared/vue/components/sf-search/search-input.vue'
import UsersFilterDropdown from './users-filter-dropdown.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useUsersListStore } from '@app/application/user-management/stores/users-list'
import {
  ALL_FILTER_VALUE,
  LAST_LOGIN_FILTER_OPTIONS,
  ROLE_FILTER_OPTIONS,
  STATUS_FILTER_OPTIONS,
} from '@app/application/user-management/constants'

defineOptions({ name: 'UsersToolbar' })

const I18n = useI18n()
const usersList = useUsersListStore()

const { list, search, role, status, lastLogin, isFiltered } =
  storeToRefs(usersList)
const { setSearch, setRole, setStatus, setLastLogin, clearFilters } = usersList

const roleOptions = computed(() => ROLE_FILTER_OPTIONS[list.value])
</script>
